class Pet {
  constructor(client) {
    this.client = client;
  }

  getPetDetails(id) {
    return this.client.get(`/pets/${id}`);
  }

  getAllPets() {
    return this.client.get('/pets');
  }

  addPet(payload) {
    return this.client.post('/pets', payload);
  }

  addMultiplePet(payload) {
    return this.client.post('/pets/bulk-add', payload);
  }

  editPet(id, payload) {
    return this.client.put(`/Pets/${id}`, payload);
  }

  deletePet(id) {
    return this.client.delete(`/Pets/${id}`);
  }
}

export default Pet;
